<div (infiniteScroll)="getNextBatch()" class="table-cell-relationship-list"
  [complete]="!sapi.loadNext" [item_height]="20" msDivInfiniteScroll>
  @for (item of list; track $index) {
    <div class="row center">
      @if (editFunction) {
        <i class="edit-inline hide-xs" (click)="editFunction(item, parent)"
        style="min-width:30px;"></i>
      }
      <div style="cursor:pointer;padding-top:2px;">{{item}}</div>
    </div>
  }
</div>
